export default __webpack_public_path__ + "locales/sk/JavascriptSdk.json?hash=bc297880e2045a5dd18418469c17416c";